import { ExtendedHomecard } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Rating.css';
import '@spotahome/ui-library/lib/components/Price.css';
import '@spotahome/ui-library/lib/components/Flip.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardImage.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardWrapper.css';
import '@spotahome/ui-library/lib/components/Homecard/PlainHomecard/HomecardContent.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';
import '@spotahome/ui-library/lib/components/Homecard/ExtendedHomecard/ExtendedHomecardImage.css';
import '@spotahome/ui-library/lib/components/Homecard/ExtendedHomecard/ExtendedHomecardContent.css';

import './HomeCardLabels.scss';

export default ExtendedHomecard;
